"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AggregationMethod = require("./AggregationMethod");

Object.keys(_AggregationMethod).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AggregationMethod[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AggregationMethod[key];
    }
  });
});

var _AnalyticsRoles = require("./AnalyticsRoles");

Object.keys(_AnalyticsRoles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AnalyticsRoles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AnalyticsRoles[key];
    }
  });
});

var _CalendarEventStatus = require("./CalendarEventStatus");

Object.keys(_CalendarEventStatus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarEventStatus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CalendarEventStatus[key];
    }
  });
});

var _CalendarName = require("./CalendarName");

Object.keys(_CalendarName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CalendarName[key];
    }
  });
});

var _CalendarType = require("./CalendarType");

Object.keys(_CalendarType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CalendarType[key];
    }
  });
});

var _Category = require("./Category");

Object.keys(_Category).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Category[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Category[key];
    }
  });
});

var _ColumnType = require("./ColumnType");

Object.keys(_ColumnType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ColumnType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ColumnType[key];
    }
  });
});

var _ColumnValue = require("./ColumnValue");

Object.keys(_ColumnValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ColumnValue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ColumnValue[key];
    }
  });
});

var _DatasetPropertyType = require("./DatasetPropertyType");

Object.keys(_DatasetPropertyType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DatasetPropertyType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DatasetPropertyType[key];
    }
  });
});

var _DatasetType = require("./DatasetType");

Object.keys(_DatasetType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DatasetType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DatasetType[key];
    }
  });
});

var _DateLike = require("./DateLike");

Object.keys(_DateLike).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DateLike[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DateLike[key];
    }
  });
});

var _DateRange = require("./DateRange");

Object.keys(_DateRange).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DateRange[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DateRange[key];
    }
  });
});

var _dates = require("./dates");

Object.keys(_dates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dates[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dates[key];
    }
  });
});

var _EmptyObject = require("./EmptyObject");

Object.keys(_EmptyObject).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmptyObject[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _EmptyObject[key];
    }
  });
});

var _EventType = require("./EventType");

Object.keys(_EventType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EventType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _EventType[key];
    }
  });
});

var _ExceptionOriginTag = require("./ExceptionOriginTag");

Object.keys(_ExceptionOriginTag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExceptionOriginTag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExceptionOriginTag[key];
    }
  });
});

var _FieldDataType = require("./FieldDataType");

Object.keys(_FieldDataType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FieldDataType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FieldDataType[key];
    }
  });
});

var _FormConditionalOperator = require("./FormConditionalOperator");

Object.keys(_FormConditionalOperator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormConditionalOperator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FormConditionalOperator[key];
    }
  });
});

var _FormTemplateFieldTypes = require("./FormTemplateFieldTypes");

Object.keys(_FormTemplateFieldTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormTemplateFieldTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FormTemplateFieldTypes[key];
    }
  });
});

var _GenericLogLimitType = require("./GenericLogLimitType");

Object.keys(_GenericLogLimitType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GenericLogLimitType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GenericLogLimitType[key];
    }
  });
});

var _GenericLogLoggedItemType = require("./GenericLogLoggedItemType");

Object.keys(_GenericLogLoggedItemType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GenericLogLoggedItemType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GenericLogLoggedItemType[key];
    }
  });
});

var _GenericLogStatus = require("./GenericLogStatus");

Object.keys(_GenericLogStatus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GenericLogStatus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GenericLogStatus[key];
    }
  });
});

var _GenericLogType = require("./GenericLogType");

Object.keys(_GenericLogType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GenericLogType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GenericLogType[key];
    }
  });
});

var _GeoJson = require("./GeoJson");

Object.keys(_GeoJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GeoJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GeoJson[key];
    }
  });
});

var _HttpStatusCode = require("./HttpStatusCode");

Object.keys(_HttpStatusCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HttpStatusCode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HttpStatusCode[key];
    }
  });
});

var _Id = require("./Id");

Object.keys(_Id).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Id[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Id[key];
    }
  });
});

var _IntervalFrequencies = require("./IntervalFrequencies");

Object.keys(_IntervalFrequencies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IntervalFrequencies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _IntervalFrequencies[key];
    }
  });
});

var _KeyCodes = require("./KeyCodes");

Object.keys(_KeyCodes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _KeyCodes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _KeyCodes[key];
    }
  });
});

var _LimitSource = require("./LimitSource");

Object.keys(_LimitSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LimitSource[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LimitSource[key];
    }
  });
});

var _LogEntriesExportLimit = require("./LogEntriesExportLimit");

Object.keys(_LogEntriesExportLimit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogEntriesExportLimit[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LogEntriesExportLimit[key];
    }
  });
});

var _LogResourceType = require("./LogResourceType");

Object.keys(_LogResourceType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogResourceType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LogResourceType[key];
    }
  });
});

var _MapLayerTags = require("./MapLayerTags");

Object.keys(_MapLayerTags).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MapLayerTags[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MapLayerTags[key];
    }
  });
});

var _MapLayerType = require("./MapLayerType");

Object.keys(_MapLayerType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MapLayerType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MapLayerType[key];
    }
  });
});

var _MapWaterSampleType = require("./MapWaterSampleType");

Object.keys(_MapWaterSampleType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MapWaterSampleType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MapWaterSampleType[key];
    }
  });
});

var _NonEmptyArray = require("./NonEmptyArray");

Object.keys(_NonEmptyArray).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NonEmptyArray[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NonEmptyArray[key];
    }
  });
});

var _NullableBoolean = require("./NullableBoolean");

Object.keys(_NullableBoolean).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NullableBoolean[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NullableBoolean[key];
    }
  });
});

var _NullableDate = require("./NullableDate");

Object.keys(_NullableDate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NullableDate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NullableDate[key];
    }
  });
});

var _NullableDateLike = require("./NullableDateLike");

Object.keys(_NullableDateLike).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NullableDateLike[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NullableDateLike[key];
    }
  });
});

var _NullableNumber = require("./NullableNumber");

Object.keys(_NullableNumber).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NullableNumber[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NullableNumber[key];
    }
  });
});

var _NullableString = require("./NullableString");

Object.keys(_NullableString).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NullableString[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NullableString[key];
    }
  });
});

var _PdfOptions = require("./PdfOptions");

Object.keys(_PdfOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PdfOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PdfOptions[key];
    }
  });
});

var _PermissionRoles = require("./PermissionRoles");

Object.keys(_PermissionRoles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PermissionRoles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PermissionRoles[key];
    }
  });
});

var _Permissions = require("./Permissions");

Object.keys(_Permissions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Permissions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Permissions[key];
    }
  });
});

var _ProjectModuleName = require("./ProjectModuleName");

Object.keys(_ProjectModuleName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProjectModuleName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ProjectModuleName[key];
    }
  });
});

var _PushNotifications = require("./PushNotifications");

Object.keys(_PushNotifications).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PushNotifications[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PushNotifications[key];
    }
  });
});

var _RenameProperties = require("./RenameProperties");

Object.keys(_RenameProperties).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RenameProperties[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RenameProperties[key];
    }
  });
});

var _SingleItemArray = require("./SingleItemArray");

Object.keys(_SingleItemArray).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SingleItemArray[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SingleItemArray[key];
    }
  });
});

var _StateAbbreviations = require("./StateAbbreviations");

Object.keys(_StateAbbreviations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StateAbbreviations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StateAbbreviations[key];
    }
  });
});

var _Substances = require("./Substances");

Object.keys(_Substances).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Substances[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Substances[key];
    }
  });
});

var _SwpppUpdates = require("./SwpppUpdates");

Object.keys(_SwpppUpdates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SwpppUpdates[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SwpppUpdates[key];
    }
  });
});

var _UserSettingsKey = require("./UserSettingsKey");

Object.keys(_UserSettingsKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserSettingsKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserSettingsKey[key];
    }
  });
});

var _ViewType = require("./ViewType");

Object.keys(_ViewType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ViewType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ViewType[key];
    }
  });
});

var _WastewaterUnits = require("./WastewaterUnits");

Object.keys(_WastewaterUnits).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WastewaterUnits[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _WastewaterUnits[key];
    }
  });
});

var _workflows = require("./workflows");

Object.keys(_workflows).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _workflows[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _workflows[key];
    }
  });
});